"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = triggerOneDOMEvent;

// triggers given DOM event on given node
function triggerOneDOMEvent(_ref) {
  var node = _ref.node,
      eventName = _ref.eventName,
      triggerArgs = _ref.triggerArgs;
  var _window = window,
      document = _window.document,
      Event = _window.Event;
  var event; // polyfill for older browsers

  if (document.createEvent) {
    /* istanbul ignore next */
    event = document.createEvent('Event');
    event.initEvent(eventName, true, true);
  } else if (typeof Event !== 'undefined') {
    event = new Event(eventName, {
      bubbles: true,
      cancelable: true
    });
  } // seempleTriggerArgs will be used in a handler created by addDOMListener


  event.seempleTriggerArgs = triggerArgs;
  node.dispatchEvent(event);
}
//# sourceMappingURL=_triggeronedomevent.js.map